// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"f9075280","453":"fe151b38"}[chunkId] + ".chunk.js";
};